import { ReactNode } from 'react'

import { SheetContentAction } from '../DataTableV2/components/SheetContentAction'
import { DataTableV2DataRow, DataTableV2SheetContentAction } from '../DataTableV2/types'
import { CardClickTarget } from './CardClickTarget'
import { CardData } from './types'

export function CardSheetContentAction({
  action,
  data,
  children,
}: {
  action: DataTableV2SheetContentAction
  data: CardData
  children: ReactNode
}) {
  return (
    <SheetContentAction
      action={action}
      trigger={(onOpen) => (
        <CardClickTarget disabled={action.isDisabled} onClick={onOpen}>
          {children}
        </CardClickTarget>
      )}
      formData={data as unknown as DataTableV2DataRow}
      isDisabled={action.isDisabled}
    />
  )
}
